import _extends from "@babel/runtime/helpers/extends";
import { Box, Divider, Text, TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common/lazy';
import React, { useState } from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useIsMobile } from '../../hooks/useIsMobile';
import { tldAlternativesApiClient } from './TldAlternativesWithPrice.apiClient';
import { parseDomain } from '@wix/domains-serverless-interface';
import s from './TldAlternativesWithPrice.css';
export const TldAlternativesWithPrice = _ref => {
  let {
    heroDomain,
    disabled,
    withDivider = false,
    containerProps
  } = _ref;
  const {
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  const {
    resolveActionForSuggestion
  } = DomainSearchSuiteModule.SDK.useSuggestionActionResolver();
  const isMobile = useIsMobile();
  const [isExpanded, setIsExpanded] = useState(true);
  const {
    sld
  } = parseDomain(heroDomain);
  const {
    data,
    isLoading,
    error
  } = tldAlternativesApiClient.hooks.useTldAlternatives({
    heroDomain
  }, Boolean(heroDomain), {
    useErrorBoundary: false
  });
  if (error) {
    return null;
  }
  const alternatives = (data == null ? void 0 : data.alternatives) ?? [];
  if (!isLoading && !alternatives.length) {
    return null;
  }
  const handleGetItClick = async recommendation => {
    const position = alternatives.findIndex(_ref2 => {
      let {
        id
      } = _ref2;
      return id === recommendation.id;
    });
    DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
      domain: recommendation.domain || '',
      type: recommendation.label,
      position: position < 0 ? 0 : position,
      origin: 'hero_card_tld_alternatives'
    });
    if (recommendation.domain) {
      await resolveActionForSuggestion(recommendation.domain, recommendation.premium);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, withDivider && !isMobile && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    gap: "SP3"
  }, containerProps), isMobile ? /*#__PURE__*/React.createElement(Box, {
    className: s.ToggleButton
  }, /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    skin: "dark",
    underline: "always",
    suffixIcon: isExpanded ? /*#__PURE__*/React.createElement(ChevronUp, null) : /*#__PURE__*/React.createElement(ChevronDown, null),
    onClick: () => setIsExpanded(prev => !prev)
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.results.more_extensions.cta",
    values: {
      domainSLD: sld
    }
  }))) : /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.results.more_extensions.cta",
    values: {
      domainSLD: sld
    }
  })), (!isMobile || isExpanded) && /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.TldAlternatives, {
    disabled: disabled,
    alternatives: alternatives,
    isLoading: isLoading,
    onClickGetIt: handleGetItClick,
    useMobileLayout: isMobile
  })));
};
//# sourceMappingURL=TldAlternativesWithPrice.js.map